import { BASE_URLS } from "../components/API";
import localforage from "localforage";

let storage = {};

export const decodeURLParams = search => {
  const hashes = search.slice(search.indexOf("?") + 1).split("&");
  return hashes.reduce((params, hash) => {
    const split = hash.indexOf("=");

    if (split < 0) {
      return Object.assign(params, {
        [hash]: null
      });
    }

    const key = hash.slice(0, split);
    const val = hash.slice(split + 1);

    return Object.assign(params, { [key]: decodeURIComponent(val) });
  }, {});
};

export const objectToQueryParams = obj => {
  return Object.keys(obj).reduce(
    (prev, key, i) => `${prev}${i !== 0 ? "&" : ""}${key}=${obj[key]}`,
    ""
  );
};

export const parseGeonames = geoNames => {
  let geoPlaces = [];

  for (var i = 0; i < geoNames.length; i++) {
    var place = geoNames[i];
    var countryCode = place.countryCode.toLowerCase();
    var aux = countryCode === "gb" ? "-" + place.adminCode1.toLowerCase() : "";
    geoPlaces.push({
      TeamTown: place.name,
      TeamGeonameID: place.geonameId,
      TeamCounty: place.adminName2,
      TeamCountry: place.countryName,
      TeamCountryCode: place.countryCode,
      TeamLatitude: place.lat,
      TeamLongitude: place.lng,
      TeamTimeZoneName: place.timezone.timeZoneId,
      AdminName: place.adminName1,
      AdminCode: place.adminCode1,
      TeamFlagUrl: `${BASE_URLS.ROOT}/teamstats-media/icons/flags/${countryCode}${aux}.png`
    });
  }

  return geoPlaces;
};

export const getStorageData = async _callback => {
  try {
    if (_callback) {
      localforage.getItem("tsStoragedata").then(_data => {
        storage = _data || {};
        _callback(storage);
      });
    } else {
      storage = (await localforage.getItem("tsStoragedata")) || {};
      return storage;
    }
  } catch (_error) {
    console.log(_error);
    return null;
  }
};

export const clearStorageData = () => {
  localforage.removeItem("tsStoragedata");
};

export const setStorageData = (_key, _value) => {
  try {
    if (_key !== undefined && _value !== undefined) {
      let _update = {};
      _update[_key] = _value;
      Object.assign(storage, _update);
      return localforage.setItem("tsStoragedata", storage);
    } else {
      console.error(
        `You must supply a key and value, you passed: key ${_key} and value ${_value}`
      );
    }
  } catch (error) {
    console.log(error);
  }
};

export const sortArrayOfObjectsByProp = (arr, prop) => {
  return arr.sort((a, b) => {
    if (a[prop] < b[prop]) {
      return -1;
    }
    if (a[prop] > b[prop]) {
      return 1;
    }
    return 0;
  });
};

export const removeDuplicatesByProp = function(array, prop) {
  const sorted = sortArrayOfObjectsByProp(array, prop);
  //console.log("sorted", sorted);
  return sorted.filter(function(item, index) {
    return index > 0 ? item[prop] !== sorted[index - 1][prop] : true;
  });
};

export const getSmartlookData = () => {
  if (window.smartlook) {
    return {
      smartlookId: window.smartlook.recordId,
      smartlookUrl: window.smartlook.playUrl
    };
  }
  const notInitMessage = "Smartlook not initialised";
  return {
    smartlookId: notInitMessage,
    smartlookUrl: notInitMessage
  };
};

// eslint-disable-next-line
export const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
